var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"messages"},[_vm._m(0),_c('ul',{staticClass:"messages-item"},_vm._l((_vm.$messages.messages),function(message){return _c('Message',{key:message.id,attrs:{"message":message}})}),1)])
}
var staticRenderFns = [function (){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"title"},[_c('span',{staticClass:"title-icon"}),_vm._v(" Last Messages ")])
}]

export { render, staticRenderFns }